import { AggregateScoreType } from "~/operations";
import { SelectedEntity } from "~/hooks/useSelection";
import { SelectedEntityWithAggregateScoresData } from "~/components/FirewatchPage";

export type GetExceptionEntitiesMrnsReturn = {
  advisoryMrns?: Array<string>;
  cveMrns?: Array<string>;
  queryMrns?: Array<string>;
  fexMrns?: Array<string>;
  applyToCves?: boolean;
};

type GetExceptionEntitiesMrnsParams = {
  selectedEntities: Array<
    SelectedEntity & SelectedEntityWithAggregateScoresData
  >;
};

export function sortAggregateToExceptionEntitiesMrns({
  selectedEntities,
}: GetExceptionEntitiesMrnsParams): GetExceptionEntitiesMrnsReturn {
  return selectedEntities.reduce<GetExceptionEntitiesMrnsReturn>(
    (agg, currentValue) => {
      switch (currentValue.scoreType) {
        case AggregateScoreType.Advisory:
          agg.advisoryMrns = agg.advisoryMrns?.length
            ? [...agg.advisoryMrns, currentValue.mrn]
            : [currentValue.mrn];
          agg.applyToCves = true;
          break;
        case AggregateScoreType.Vulnerability:
          agg.cveMrns = agg.cveMrns?.length
            ? [...agg.cveMrns, currentValue.mrn]
            : [currentValue.mrn];
          break;
        case AggregateScoreType.Check:
        default:
          agg.queryMrns = agg.queryMrns?.length
            ? [...agg.queryMrns, currentValue.mrn]
            : [currentValue.mrn];
      }

      return agg;
    },
    {},
  );
}
